
import * as defaultImport from "@splunk/dashboard-definition";
export * from "@splunk/dashboard-definition";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
